import { isNil } from 'lodash-es';

export default () => {
  const calculateMarginPercentage = (price: number, cost: number): string => {
    if (isNil(price) || isNil(cost)) {
      return;
    }

    const margin = price - cost;

    const marginPercentage = (margin / price) * 100;

    // Round the margin percentage to avoid floating-point precision issues
    const roundedMarginPercentage = Math.round(marginPercentage * 100) / 100;

    const value = Number.isInteger(roundedMarginPercentage)
      ? Math.floor(roundedMarginPercentage) // If it is an integer, use the floored value
      : roundedMarginPercentage;

    return `${value}%`;
  };
  return { calculateMarginPercentage };
};
